<template>
  <div class="columns">
    <div class="column is-four-fifths is-vcentered">
      <b-pagination
            class="mgt-40px"
            @change="changeHandler"
            :total="total"
            v-model="page.current"
            :range-before="3"
            :range-after="3"
            order="is-centered"
            :simple="false"
            :rounded="false"
            :per-page="page.limit">
      </b-pagination>
    </div>
    <div class="column is-vcentered">
      <table-items-in-view @input="limitInputHandler"/>
    </div>
  </div>
</template>

<script>
import TableItemsInView from '@/components/general/TableItemsInView';

export default {
  props: {
    total: {
      type: Number,
      required: false,
      default: 0,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    page: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  components: {
    TableItemsInView,
  },
  methods: {
    limitInputHandler(value) {
      this.page = { ...this.page, limit: value };
    },
    changeHandler(value) {
      this.page = { ...this.page, current: value };
    },
  },
};
</script>

<style>

</style>
